module.exports = __webpack_public_path__ + "img/2_nike.6ce17451.jpg";